export default __webpack_public_path__ + "static/why_2-b219deaa34ef3aec6d5800c501d9c25b.gif";